(() => {
  'use strict';
  if (window.NexusCuisineHome) {
    window.NexusCuisineHome.init(document);
    return;
  }
  const controllers = new WeakMap();
  const sessionKey = 'nh-cf-announcement-2026-v1';

  function setup(root) {
    if (controllers.has(root)) return;
    const dialog = root.querySelector('.nh-cf-dialog');
    if (!dialog || typeof dialog.showModal !== 'function') {
      root.querySelectorAll('[data-nh-cf-open]').forEach((button) => { button.hidden = true; });
      return;
    }
    const abort = new AbortController();
    const signal = abort.signal;
    let timer;
    let previousFocus;
    let previousOverflow;
    let scrollLocked = false;
    let focusStory = false;
    const markSeen = () => {
      try { sessionStorage.setItem(sessionKey, '1'); } catch (_) { /* Storage may be disabled. */ }
      window.NexusCuisineHome.seen = true;
    };
    const hasSeen = () => {
      try { return window.NexusCuisineHome.seen || sessionStorage.getItem(sessionKey) === '1'; }
      catch (_) { return window.NexusCuisineHome.seen; }
    };
    const restoreScroll = () => {
      if (!scrollLocked) return;
      if (document.body.style.overflow === 'hidden') document.body.style.overflow = previousOverflow;
      scrollLocked = false;
    };
    const open = () => {
      if (dialog.open || !root.isConnected) return;
      previousFocus = document.activeElement;
      focusStory = false;
      dialog.showModal();
      dialog.scrollTop = 0;
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      scrollLocked = true;
      dialog.querySelector('.popup-card')?.focus({ preventScroll: true });
      markSeen();
    };
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const trigger = event.target.closest('[data-nh-cf-open]');
      if (trigger?.getAttribute('aria-controls') === dialog.id) {
        event.preventDefault();
        open();
      }
    }, { signal });
    root.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const closer = event.target.closest('[data-nh-cf-close]');
      if (closer && dialog.contains(closer)) {
        focusStory = closer instanceof HTMLAnchorElement;
        dialog.close();
      }
    }, { signal });
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }, { signal });
    dialog.addEventListener('close', () => {
      restoreScroll();
      if (focusStory) {
        document.getElementById('nh-cf-story')?.focus({ preventScroll: true });
      } else if (previousFocus instanceof HTMLElement && previousFocus.isConnected && previousFocus !== document.body) {
        previousFocus.focus({ preventScroll: true });
      }
    }, { signal });
    if (root.dataset.autoPopup === 'true' && root.dataset.designMode !== 'true' && !hasSeen()) {
      timer = window.setTimeout(() => {
        const editing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
        if (!hasSeen() && !document.querySelector('dialog[open]') && !editing && document.visibilityState === 'visible') open();
      }, 1200);
    }
    controllers.set(root, () => {
      window.clearTimeout(timer);
      if (dialog.open) dialog.close();
      restoreScroll();
      abort.abort();
      controllers.delete(root);
    });
  }
  function init(scope) {
    if (scope.matches?.('[data-nh-cf-section]')) setup(scope);
    scope.querySelectorAll('[data-nh-cf-section]').forEach(setup);
    document.querySelectorAll('[data-nh-cf-open]').forEach((button) => {
      const target = document.getElementById(button.getAttribute('aria-controls'));
      button.hidden = !target || typeof target.showModal !== 'function';
    });
  }
  window.NexusCuisineHome = { init, seen: false };
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-nh-cf-section]').forEach((root) => controllers.get(root)?.());
  });
  init(document);
})();
